import { useEffect } from 'react';

interface PostAuthModalProps {
  source: 'cli' | 'web';
  onClose: () => void;
}

export function PostAuthModal({ source, onClose }: PostAuthModalProps) {
  // Auto-close after 10 seconds
  useEffect(() => {
    const timer = setTimeout(onClose, 10000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const isCli = source === 'cli';

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: 'var(--bg-subtle)',
          border: '1px solid var(--border-light)',
          borderRadius: '8px',
          padding: '2rem',
          maxWidth: '500px',
          width: '90%',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            marginBottom: '1rem',
          }}
        >
          <div
            style={{
              width: '48px',
              height: '48px',
              borderRadius: '50%',
              backgroundColor: isCli ? 'var(--success-bg)' : 'var(--info-bg)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.5rem',
            }}
          >
            {isCli ? '✓' : 'ℹ'}
          </div>
          <h2
            style={{
              fontSize: '1.25rem',
              fontWeight: '600',
              color: 'var(--text-primary)',
              margin: 0,
            }}
          >
            {isCli ? 'CLI Setup Complete!' : 'Web Version'}
          </h2>
        </div>

        {isCli ? (
          <>
            <p
              style={{
                marginBottom: '1rem',
                color: 'var(--text-secondary)',
                lineHeight: '1.6',
              }}
            >
              Ceetrix MCP server is now installed in your Claude Code terminal.
            </p>
            <p
              style={{
                marginBottom: '1.5rem',
                color: 'var(--text-secondary)',
                lineHeight: '1.6',
              }}
            >
              You can now use the full power of Ceetrix in your terminal. This web interface is optional and provides a visual overview of your backlogs.
            </p>
          </>
        ) : (
          <>
            <p
              style={{
                marginBottom: '1rem',
                color: 'var(--text-secondary)',
                lineHeight: '1.6',
              }}
            >
              This is the web version of Ceetrix. Most of the fun is in the terminal with Claude Code.
            </p>
            <p
              style={{
                marginBottom: '1.5rem',
                color: 'var(--text-secondary)',
                lineHeight: '1.6',
              }}
            >
              To get the full experience, run{' '}
              <code
                style={{
                  backgroundColor: 'var(--bg-muted)',
                  padding: '0.125rem 0.375rem',
                  borderRadius: '3px',
                  fontFamily: 'monospace',
                  fontSize: '0.875em',
                }}
              >
                npx ceetrix
              </code>{' '}
              in your terminal to install the MCP server in Claude Code.
            </p>
          </>
        )}

        <button
          onClick={onClose}
          style={{
            width: '100%',
            padding: '0.75rem 1.5rem',
            backgroundColor: 'var(--interactive)',
            color: 'var(--text-on-brand)',
            border: 'none',
            borderRadius: '6px',
            fontSize: '1rem',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'background-color 0.15s',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'var(--interactive-hover)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'var(--interactive)';
          }}
        >
          Continue to Dashboard
        </button>
      </div>
    </div>
  );
}
